<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>DESPESAS</span>
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="$emit('atualizar')"
                            ></i>
                        </span>
                    </div>
                </h4>
                <despesas-filtros
                    :servicos="servicos"
                    @atualizarFiltro="$emit('atualizarFiltro', $event)"
                ></despesas-filtros>
                <app-tabela
                    idTabela="tblDespegasGerais"
                    :itens="despesas"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="status" slot-scope="data">
                        <app-status :status="data.status"></app-status>
                    </template> 
                    <template slot="valor" slot-scope="data">
                        {{ data.valor | currency }}
                    </template>
                    <template slot="comprometimento" slot-scope="data">
                        {{ data.idMov }}
                        <status-id-mov
                            :despesa="data"
                        ></status-id-mov>
                    </template>

                    <template slot="botoes">
                        <slot name="botoes"></slot>
                        <btn-inserir-despesas
                            v-if="temAcessoInserir"
                        ></btn-inserir-despesas>
                        <btn-buscar-movimento-compra
                            class="mr-1">
                        </btn-buscar-movimento-compra>    
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <btn-to-despesa
                            :despesaId="data.despesaId"
                            v-if="temAcessoDetalhar"
                        ></btn-to-despesa>
                        <slot name="acoes" v-bind="data"></slot>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>    
</template> 

<script>
import BtnInserirDespesas from './BtnInserirDespesas.vue';
import BtnToDespesa from './BtnToDespesa.vue';
import StatusIdMov from './StatusIdMov.vue';
import DespesasFiltros from './DespesasFiltros.vue';
import BtnBuscarMovimentoCompra from './BtnBuscarMovimentoCompra.vue';

export default {
    props: {
        despesas: {
            type: Array,
            default: () => []
        },
    
        temAcessoInserir: {
            type: Boolean,
            default: false
        },

        temAcessoDetalhar: {
            type: Boolean,
            default: () => false
        },

        servicos: {
            type: Object,
            default: () => ({}) 
        }
    },

    components: {
        BtnInserirDespesas,
        BtnToDespesa,
        StatusIdMov,
        DespesasFiltros,
        BtnBuscarMovimentoCompra
    },

    data() {
        return {
            itensPorPagina: 5,
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                // {
                //     key: 'numeroNota',
                //     label: 'Numero da nota',
                //     sortable: true,
                //     filterable: true
                // },
                {
                    key: 'sequencial',
                    label: 'Sequencial',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'cpfCnpj',
                    label:  'CNPJ do Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeFornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {   
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {   
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Anexos',
                    tdClass: 'text-center'
                },
                {
                    key: 'qtdItens',
                    label: 'Itens',
                    tdClass: 'text-center'
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'status',
                    label: 'Status',
                    tdClass: 'text-center'
                },
                {
                    key: 'protocoloPagamento',
                    label: 'Pagamento',
                    tdClass: 'text-center'
                },
                {
                    key: 'comprometimento',
                    label: 'Comprometimento',
                }
            ]
        }
    }
}

</script>